//@flow
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './BackButton.scss';

type Props = {|
    onClick: () => void,
|};

export const BackButtonComponent = (props: Props) => (
    <div className={styles.backLink}>
        <a onClick={props.onClick} data-tn="back-button">
            <span className={styles.backLinkText}>
                <FormattedMessage id="abt.matchmaker.backButton" defaultMessage="Back" />
            </span>
        </a>
    </div>
);

export const BackButton = BackButtonComponent;
